export function hashString(value: string): number {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

export function mulberry32(seed: number): () => number {
  return () => {
    let value = (seed += 0x6d2b79f5);
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };
}

export function seededRandom(key: string): () => number {
  return mulberry32(hashString(key));
}

export function smoothNoise2D(seed: string, x: number, z: number): number {
  const xi = Math.floor(x);
  const zi = Math.floor(z);
  const tx = x - xi;
  const tz = z - zi;
  const smooth = (value: number) => value * value * (3 - 2 * value);
  const sample = (sx: number, sz: number) => seededRandom(`${seed}:${sx}:${sz}`)();
  const a = sample(xi, zi);
  const b = sample(xi + 1, zi);
  const c = sample(xi, zi + 1);
  const d = sample(xi + 1, zi + 1);
  const ux = smooth(tx);
  const uz = smooth(tz);
  return a * (1 - ux) * (1 - uz) + b * ux * (1 - uz) + c * (1 - ux) * uz + d * ux * uz;
}
